import React from 'react';
import PersonalWebsite from './components/PersonalWebsite';
import './App.css';

function App() {
  return (
    <div className="App">
      <PersonalWebsite />
    </div>
  );
}

export default App;